var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_31156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 6.40039C10.7502 5.98618 10.4144 5.65039 10.0002 5.65039C9.58598 5.65039 9.2502 5.98618 9.2502 6.40039H10.7502ZM7.65449 12.2951C7.37034 12.5965 7.38431 13.0711 7.6857 13.3553C7.98708 13.6394 8.46175 13.6255 8.7459 13.3241L7.65449 12.2951ZM9.2502 6.40039V10.1062H10.7502V6.40039H9.2502ZM8.7459 13.3241L10.0011 11.9927L8.90971 10.9637L7.65449 12.2951L8.7459 13.3241ZM9.2502 10.1062C9.2502 10.425 9.1284 10.7318 8.90971 10.9637L10.0011 11.9927C10.4822 11.4824 10.7502 10.8076 10.7502 10.1062H9.2502Z",
    fill: "#FFB100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.20421C6.86757 1.41302 8.42006 0.997576 10 1.00001C14.9707 1.00001 19 5.02931 19 10C19 14.9707 14.9707 19 10 19C5.0293 19 1 14.9707 1 10C1 8.36111 1.4383 6.82301 2.2042 5.50001",
    stroke: "#FFB100",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_31156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGold);
export default __webpack_public_path__ + "static/media/clock-gold.8d602a3ff333663db0cd677161c1f75b.svg";
export { ForwardRef as ReactComponent };